import * as React from 'react';

import * as styles from './AdfoxListingBannerWrapper.css';
import { ClientComponent } from '../ClientComponent';

export const AdfoxListingBannerWrapper = ({ children }: { children: React.ReactNode }) => {
  return (
    <section className={styles['container']} data-testid="adfox_listing_tgb_wrapper">
      <ClientComponent>{children}</ClientComponent>
      <div className={styles['spacer']} />
    </section>
  );
};
